import Choices from "choices.js";

export default class Global {
    constructor() {
        this.smoothScroll();
        this.initChoices();
    }
    smoothScroll() {
        const buttons = document.querySelectorAll('.smooth-scroll');

        buttons.forEach(function(el, i) {
            el.addEventListener('click', function(ev) {
                ev.preventDefault();

                let item = document.querySelector(el.getAttribute('href'));
                let offset = item.offsetTop - document.querySelector('header').offsetHeight;

                if (document.querySelector('#property')) {
                    offset -= document.querySelector('#property nav').offsetHeight;
                }
                console.log(offset)
                window.scrollTo({
                    'behavior': 'smooth',
                    'left': 0,
                    'top': offset
                });
            });
        });
    }

    initChoices() {
        const elements = document.querySelectorAll('.js-choice');
        let choices;

        elements.forEach(element => {
            choices = new Choices(element);
        });
    }
}
